// Per-TAB persistence of the selected workspace, per shop.
//
// The selection used to live in localStorage alone, which every tab on the
// origin shares: work in workspace A in one tab, open (or reload) a second tab
// on workspace B, and whichever tab wrote last decided what the other showed
// after its next reload — reads landing in the wrong workspace, writes filed
// under it. sessionStorage is the browser's own per-tab store (its lifetime IS
// a tab), so it now holds each tab's truth; localStorage remains only as the
// cross-tab SEED so a brand-new tab still opens on the last workspace the
// person used anywhere.
//
// The '' sentinel in sessionStorage is load-bearing: "this tab explicitly
// chose Account level" must survive a reload without falling through to
// another tab's localStorage seed — a missing key means "new tab", an empty
// string means "Account, on purpose".
//
// null / missing = account level throughout, matching the context's contract.

export const workspaceStorageKey = (shopKey) => `cf_current_workspace:${shopKey || ''}`;

export function readStoredWorkspace(shopKey) {
    const key = workspaceStorageKey(shopKey);
    try {
        const tabValue = window.sessionStorage.getItem(key);
        if (tabValue !== null) return tabValue || null; // '' → Account, by this tab's choice
        return window.localStorage.getItem(key) || null; // new tab → seed from last-used
    } catch {
        return null;
    }
}

export function storeWorkspace(shopKey, workspaceId) {
    const key = workspaceStorageKey(shopKey);
    try {
        // This tab's truth — always written, '' standing in for Account.
        window.sessionStorage.setItem(key, workspaceId || '');
    } catch { /* private mode — selection just won't persist */ }
    try {
        // The cross-tab seed keeps the old shape: set or removed, never ''.
        if (workspaceId) window.localStorage.setItem(key, workspaceId);
        else window.localStorage.removeItem(key);
    } catch { /* private mode — selection just won't persist */ }
}
